import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, StringField, BooleanField, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class NeuralAmpDeviceBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new NeuralAmpDeviceBox({
            uuid,
            graph,
            name: "NeuralAmpDeviceBox",
            pointerRules: {
                accepts: [
                    Pointers.Device,
                    Pointers.Selection,
                    Pointers.MetaData,
                    Pointers.SideChain,
                ],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "NeuralAmpDeviceBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({ type: "device", deviceType: "audio-effect" });
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitNeuralAmpDeviceBox, this);
    }
    get tags() {
        return NeuralAmpDeviceBox.Tags;
    }
    get host() {
        return this.getField(1);
    }
    get index() {
        return this.getField(2);
    }
    get label() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    /** @deprecated */
    get modelJson() {
        return this.getField(10);
    }
    get inputGain() {
        return this.getField(11);
    }
    get outputGain() {
        return this.getField(12);
    }
    get mono() {
        return this.getField(13);
    }
    get mix() {
        return this.getField(14);
    }
    get model() {
        return this.getField(20);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "host",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.AudioEffectHost, true),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                deprecated: false,
                pointerRules: NoPointers,
            }, false),
            10: StringField.create({
                parent: this,
                fieldKey: 10,
                fieldName: "modelJson",
                deprecated: true,
                pointerRules: NoPointers,
            }),
            11: Float32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "inputGain",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "decibel", "dB", 0),
            12: Float32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "outputGain",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "decibel", "dB", 0),
            13: BooleanField.create({
                parent: this,
                fieldKey: 13,
                fieldName: "mono",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            14: Float32Field.create({
                parent: this,
                fieldKey: 14,
                fieldName: "mix",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 1, scaling: "linear" }, "%", 1),
            20: PointerField.create({
                parent: this,
                fieldKey: 20,
                fieldName: "model",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.NeuralAmpModel, false),
        };
    }
}
